import * as React from 'react';
import { Tabs, Tab, Stack, useTheme } from '@mui/material';
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import DiscountIcon from '@mui/icons-material/Discount';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import TableBarIcon from '@mui/icons-material/TableBar';
import PlaceIcon from '@mui/icons-material/Place';
import LandscapeIcon from '@mui/icons-material/CropSquare';



import { Printer } from '../printer';
import { ClientDiscountSettings, ClientInfo, ClientTablesSettings, ClientTaxSettings } from '../client-info';
import { FloorScreen } from '../floor';
import { PlaceScreen } from '../places';
import { TablesScreen } from '../tables';
import { FloorDesigner } from '../floor-designer';

const LayoutSettings = () => {
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const tabContent = [
        <Stack key="floor-settings" flex={1} style={{ height: "100%" }}>
            <FloorScreen />
        </Stack>,
        <Stack key="places-settings" flex={1} style={{ height: "100%" }}>
            <PlaceScreen />
        </Stack>,
        <Stack key="table-settings" flex={1} style={{ height: "100%" }}>
            <TablesScreen />
        </Stack>,
        <Stack key="floor-designer" flex={1} style={{ height: "100%" }}>
            <FloorDesigner />
        </Stack>
    ];

    return (
        <Stack flexDirection={"row"} sx={{ backgroundColor: theme.palette.background.default }}>
            <Tabs value={value} onChange={(e, v) => setValue(v)} orientation='vertical'
                sx={{ backgroundColor: theme.palette.background.default, maxWidth: 100, minWidth: 100, height: "100%" }}>
                <Tab icon={<LandscapeIcon fontSize='large' />} label="Floors" aria-label="Floor Settings" />
                <Tab icon={<PlaceIcon fontSize='large' />} label="Places" aria-label="Place Settings" />
                <Tab icon={<TableBarIcon fontSize='large' />} label="Tables" aria-label="Table Settings" />
                <Tab icon={<TableBarIcon fontSize='large' />} label="Floor Designer" aria-label="Table Settings" />
            </Tabs>
            {tabContent[value]}
        </Stack>
    );
};

export { LayoutSettings };
